/**
 * ModernAdminLayout - Enhanced admin layout using shadcn components and modern design
 */
import React from 'react';
import PropTypes from 'prop-types';
import { useAdmin, AdminProvider } from './AdminHooks';
import ModernAdminHeader from './ModernAdminHeader';
import ModernAdminContent from './ModernAdminContent';
import ModernAdminModals from './ModernAdminModals';
import { cn } from '../../lib/utils';

const LayoutInner = () => {
  const { authLoading, isAuthenticated, sidebarOpen } = useAdmin();
  
  if (authLoading) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-gradient-to-br from-slate-900 to-slate-800">
        <div className="text-center">
          <div className="mx-auto mb-4 w-12 h-12 rounded-full border-b-2 border-white animate-spin"></div>
          <p className="text-gray-400">Chargement...</p>
        </div>
      </div>
    );
  }
  
  if (!isAuthenticated) return null; // Route component handles redirect
  
  return (
    <div className="min-h-screen text-white bg-gradient-to-br from-slate-900 to-slate-800">
      <ModernAdminHeader />
      <main className={cn("py-6 pr-4 pl-4 w-full sm:pl-6 sm:pr-6 md:pl-0 lg:pr-8")}>
        <ModernAdminContent />
      </main>
      <ModernAdminModals />
    </div>
  );
};

const ModernAdminLayout = ({ children }) => (
  <AdminProvider>
    {children}
    <LayoutInner />
  </AdminProvider>
);

ModernAdminLayout.propTypes = {
  children: PropTypes.node,
};

export default ModernAdminLayout;
